import React,  from 'react'
import ReactDOM from 'react-dom'
import Main from './main.gui.tsx';

document.ontouchstart = document.ontouchmove = e => e.preventDefault();


ReactDOM.render(
  <Main />,
  document.querySelector('#root'),
)